import {
    RequestMessageDefinition,
    RespondMessageDefinition,
} from "userful-chronos-app-common-js/dist/message/messageModel";

// Notifications App messages offset:
const OFFSET = 7100;

// Message categories:
const ALERT = OFFSET + 0;
const ALERT_SCHED = OFFSET + 1;

// ALERT Request (messageSender) messages:
export const REQUEST_LIST_ALERT_CONFIGS = new RequestMessageDefinition(ALERT, 0);
export const REQUEST_ADD_ALERT_CONFIG_HEADER = new RequestMessageDefinition(ALERT, 1);
export const REQUEST_UPDATE_ALERT_CONFIG = new RequestMessageDefinition(ALERT, 2);
export const REQUEST_REMOVE_ALERT_CONFIG = new RequestMessageDefinition(ALERT, 3);
export const REQUEST_ACTIVATE_ALERT = new RequestMessageDefinition(ALERT, 4);
export const REQUEST_DEACTIVATE_ALERT = new RequestMessageDefinition(ALERT, 5);
export const REQUEST_UPDATE_AND_ACTIVATE_ALERT = new RequestMessageDefinition(ALERT, 6);

// ALERT Response (messageReciever) messages:
export const RESPOND_LIST_ALERT_CONFIGS = new RespondMessageDefinition(ALERT, 0);
export const RESPOND_ADD_ALERT_CONFIG_HEADER = new RespondMessageDefinition(ALERT, 1);
export const NOTIFY_UPDATE_ALERT_CONFIG = new RespondMessageDefinition(ALERT, 2);
export const NOTIFY_REMOVE_ALERT_CONFIG = new RespondMessageDefinition(ALERT, 3);
export const RESPOND_ACTIVATE_ALERT = new RespondMessageDefinition(ALERT, 4);
export const RESPOND_DEACTIVATE_ALERT = new RespondMessageDefinition(ALERT, 5);
export const NOTIFY_UPDATE_AND_ACTIVATE_ALERT = new RespondMessageDefinition(ALERT, 6);

export const REQUEST_LIST_ALERT_SCHED_CONFIGS = new RequestMessageDefinition(ALERT_SCHED, 0);
export const REQUEST_CREATE_ALERT_SCHED = new RequestMessageDefinition(ALERT_SCHED, 1);
export const REQUEST_UPDATE_ALERT_SCHED = new RequestMessageDefinition(ALERT_SCHED, 2);
export const REQUEST_REMOVE_ALERT_SCHED = new RequestMessageDefinition(ALERT_SCHED, 3);
export const REQUEST_ACTIVATE_ALERT_SCHED = new RequestMessageDefinition(ALERT_SCHED, 4);
export const REQUEST_DEACTIVATE_ALERT_SCHED = new RequestMessageDefinition(ALERT_SCHED, 5);

export const RESPONSE_LIST_ALERT_SCHED_CONFIGS = new RespondMessageDefinition(ALERT_SCHED, 0);
export const NOTIFY_CREATE_ALERT_SCHED = new RespondMessageDefinition(ALERT_SCHED, 1);
export const NOTIFY_UPDATE_ALERT_SCHED = new RespondMessageDefinition(ALERT_SCHED, 2);
export const NOTIFY_REMOVE_ALERT_SCHED = new RespondMessageDefinition(ALERT_SCHED, 3);
export const NOTIFY_ACTIVATE_ALERT_SCHED = new RespondMessageDefinition(ALERT_SCHED, 4);
export const NOTIFY_DEACTIVATE_ALERT_SCHED = new RespondMessageDefinition(ALERT_SCHED, 5);
